import {ApiFindOptions, useApiFind} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import { PATH as ROSTER_PATH } from '../const';
import {StubbornDatasource} from "../../../../../application/business/StubbornAsset";

export const useRosterDatasourceFind = (options: ApiFindOptions = {}) => useApiFind<Pick<StubbornDatasource, 'name' | 'kind'>>(`${ROSTER_PATH}${PATH}`, options);
